import React, {PureComponent} from "react"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

interface Props extends InjectIntl {
  value: string
  onChange?: (value: string) => void
  onBlur?: (value: string) => void
  validation?: () => any
}

class Lastname extends PureComponent<Props> {
  buildLastNameSchema = () => {
    const {formatMessage} = this.props
    return Validation.string("platform.defaultValidation.required")
      .min(1, formatMessage({id: "platform.fields.lastName.minLength"}))
      .max(50, formatMessage({id: "platform.fields.lastName.maxLength"}))
      .test("notJustSpaces", "platform.fields.lastName.notJustSpaces", (value: string) => value && value.trim().length !== 0)
      .matches(/^([^0-9]*)$/, "platform.fields.lastName.notNumeric")
  }

  render() {
    const {validation, formatMessage, ...props} = this.props
    return (
      <Input
        name="lastname"
        label={formatMessage({id: "platform.fields.lastName.label"})}
        {...props}
        validation={validation || this.buildLastNameSchema()}
      />
    )
  }
}

export default injectIntl(Lastname)
